import { render, staticRenderFns } from "./CalendarPage.vue?vue&type=template&id=498cc49f&"
import script from "./CalendarPage.vue?vue&type=script&lang=js&"
export * from "./CalendarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports